// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'undock';

export const Component = () => (
  <path
    stroke='currentColor'
    strokeLinecap='round'
    d='M16.25 1.75 10.5 7.5m5.75-1V1.75m-4.75 0h4.75m-14.5 14.5L7.5 10.5m-5.75 1v4.75m4.75 0H1.75'
  />
);

export const viewBox = '0 0 18 18';
